module.exports = __webpack_public_path__ + "img/44_19.024b5797.png";